"use client";

import React, { useEffect, useRef, useState } from "react";

const SectionHeader = ({ title, leftAlign }: { title: string, leftAlign?: boolean }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`grid place-content-${leftAlign ? 'start' : 'center'}`}>
      <h2 
        className={`px-3 md:px-3.5 lg:px-4.5 xl:px-6 py-2 xl:py-2.5 outline outline-primary bg-primary/10 text-primary rounded-[50px] font-medium text-base lg:text-xl xl:text-2xl uppercase w-fit transform transition-all duration-[1200ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] ${
          isVisible ? "scale-100 opacity-100" : "scale-50 opacity-0"
        }`}
      >
        {title}
      </h2>
    </div>
  );
};

export default SectionHeader;
